import React from "react";
import ContactForm, { ContactInfo } from "../components/ContactForm";
import SEO from "../components/SEO";
import { useI18n } from "../lib/i18n";
import { useSettings } from "../lib/settings";
import { T } from "../lib/autoTranslate";

const ContactPage = () => {
  const { t } = useI18n();
  const { settings } = useSettings();
  const s = settings || {};
  return (
    <section className="section bg-[var(--ri-cream)]">
      <SEO
        title="Contact · Free Istanbul Tours"
        description="Get in touch with Free Istanbul Tours. Message our local team for tour inquiries, private bookings and custom itineraries in Istanbul."
        path="/contact"
      />
      <div className="container-x">
        <p className="eyebrow mb-3">Contact</p>
        <h1 className="font-serif-display text-[44px] md:text-[60px] leading-[1.02] max-w-[720px]">
          <T>{s.contact_page_title || t("contact_title")}</T>
        </h1>
        <p className="mt-5 max-w-[620px] text-[17px] leading-[1.7] text-[var(--ri-ink-soft)]">
          <T>{s.contact_page_subtitle || t("contact_sub")}</T>
        </p>

        <div className="mt-14 grid lg:grid-cols-[1fr_360px] gap-12">
          <div className="bg-[#fffdf7] rounded-2xl border border-[var(--ri-border)] p-8">
            <ContactForm />
          </div>
          <aside>
            <h3 className="font-serif-display text-[22px] mb-6"><T>{s.contact_page_aside_title || "Where to find us"}</T></h3>
            <ContactInfo />
            <div className="mt-8 pt-6 border-t border-[var(--ri-border)] text-[14px] text-[var(--ri-muted)]">
              {s.contact_page_note ? (
                <div dangerouslySetInnerHTML={{ __html: s.contact_page_note }} />
              ) : (
                <T>Our office and meeting point are both in the Old City. Full meeting instructions are sent with your booking confirmation.</T>
              )}
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
};

export default ContactPage;
